import React, { useState } from "react";
import { Card, Input, Button, Spin, Typography, Divider } from 'antd';
import { SaveOutlined, CloseOutlined, PlusOutlined, DeleteOutlined,EditOutlined } from '@ant-design/icons';
import { RichTextEditor } from './RichTextEditor';
import { templateTypeLabels } from '../../data/emailTemplates';

const { Title, Text } = Typography;

export const TemplateEditorForm = ({
  selectedType,
  template,
  isSaving,
  onClose,
  onSubjectChange,
  onContentChange,
  onEmailChange,
  onAddEmail,
  onRemoveEmail,
  onSave,
  onReset,
  onPreview,
}) => {
  const [editTextArea, seteditTextArea] = useState(false);

  if (!selectedType || !template) return null;

  return (
    <Card 
      bordered
      styles={{ body: { padding: 24 } }}
    >
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div>
          <div style={{ marginBottom: 4, fontWeight:'700', fontSize:20 }}>
            Edit {templateTypeLabels[selectedType]}
          </div>
          
        </div>
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
        {/* Subject Line */}
        <div>
          <Text  style={{ display: 'block', marginBottom: 8,fontWeight:'700',textAlign:'left' }}>
            Email Subject
          </Text>
          <Input
            size="large"
            value={template.subject}
            onChange={(e) => onSubjectChange(e.target.value)}
            placeholder="Enter email subject..."
          />
        </div>

        {/* Receiver Emails */}
        <div>
          <Text  style={{ display: 'block', marginBottom: 8,fontWeight:'700',textAlign:'left' }}>
            Admin Receiver Email Addresses
          </Text>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {(template.receiverEmails || []).map((email, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Input
                  size="large"
                  value={email}
                  onChange={(e) => onEmailChange(index, e.target.value)}
                  placeholder="Enter email address..."
                  style={{ flex: 1 }}
                />
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => onRemoveEmail(index)}
                />
              </div>
            ))}
            <Button
              type="dashed"
              icon={<PlusOutlined />}
              onClick={onAddEmail}
              block
            >
              Add Email Address
            </Button>
          </div>
          <Text type="secondary" style={{ fontSize: 12, marginTop: 8, display: 'block' }}>
            These admin emails will receive this notification.
          </Text>
        </div>

        {/* Rich Text Editor */}
        <div style={{ position: 'relative' }}>
          <Text  style={{ display: 'block', marginBottom: 8,fontWeight:'700',textAlign:'left' }}>
            Email Body
          </Text>
          {editTextArea ? (
            <div>
              <RichTextEditor
                value={template.content}
                onChange={onContentChange}
              />
              <Button
                size="small"
                type="text"
                icon={<CloseOutlined />}
                onClick={() => seteditTextArea(false)}
                style={{ marginTop: 8 }}
              >
                Close Editor
              </Button>
            </div>
          ) : (
            <div style={{ position: 'relative' }}>
              <div
                className="emailCopy"
                dangerouslySetInnerHTML={{
                  __html: template.content,
                }}
                style={{ paddingRight: 40 }}
              />
              <EditOutlined
                style={{
                  position: "absolute",
                  top: 5,
                  right:5,
                  fontSize: 18,
                  color: "#999",
                  cursor: "pointer",
                }}
                onClick={() => {
                  seteditTextArea(true);
                }}
              />
            </div>
          )}
        </div>

        {/* Last Modified Info */}
        {/* <Text type="secondary" style={{ fontSize: 12 }}>
          Last modified: {template.lastModified.toLocaleString()}
        </Text> */}

        <Divider style={{ margin: '8px 0' }} />

        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: 12 }}>
          <Button
            type="primary"
            size="large"
            icon={isSaving ? <Spin size="small" /> : ""}
            onClick={onSave}
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save Template'}
          </Button>
          <Button
            size="large"
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Card>
  );
};
